<template>
  <b-container>
    <label for="email-input"
      >If you are new to Simplify, please enter your email address to register</label
    >
    <b-input
      id="email-input"
      v-model="email"
      class="mb-4"
      placeholder="Please enter your email address.."
      type="email"
    ></b-input>

    <b-button
      :class="['mb-4', 'login-button-text']"
      block
      pill
      style="height: 40px;"
      variant="info"
      @click="redirectToLogin"
      ><em class="fa fa-user" style="font-size:22px;line-height:16px;"></em>&nbsp; Login to Simplify
    </b-button>
  </b-container>
</template>

<script>
  export default {
    name: 'external-login',
    props: {
      exostarCognitoUrl: String,
    },
    data() {
      return {
        email: '',
        eipUrl: '',
      };
    },
    methods: {
      async redirectToLogin() {
        if (this.email) {
          await this.generateEipUrl(this.email);
        } else {
          window.location.href = this.exostarCognitoUrl;
        }
      },
      async generateEipUrl() {
        await axios
          .create()
          .post('api/exo-redirect', { email: this.email })
          .then(r => {
            window.location.href = r.data['eipUrl'];
          })
          .catch(e => {
            console.error(e);
          });
      },
    },
  };
</script>
